var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.auctionOver && !_vm.timeOver)?_c('v-sheet',{staticClass:"lighten-4 d-flex align-center justify-center",class:{ primary: _vm.open, warning: !_vm.open },attrs:{"height":"10vh"}},[_c('h3',[_vm._v(_vm._s(_vm.leftTime))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }